import { Link } from "react-router-dom";
import { useCmsMenu } from "@/hooks/useCms";

const FooterCmsMenu = () => {
  const { data: items = [] } = useCmsMenu("footer");
  if (items.length === 0) return null;
  return (
    <ul className="space-y-1.5 pt-2 border-t border-border/30 mt-2">
      {items.map((it, i) => {
        const isExternal = it.url.startsWith("http");
        const cls = "text-sm text-muted-foreground hover:text-primary transition-colors";
        return (
          <li key={i}>
            {isExternal ? (
              <a href={it.url} target="_blank" rel="noopener noreferrer" className={cls}>{it.label}</a>
            ) : (
              <Link to={it.url} className={cls}>{it.label}</Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default FooterCmsMenu;
